import {v4 as uuidv4} from "uuid";
import {none, option} from "ts-option";
import BaseFormController from "../../../../validation/BaseFormController";
import {FormField, RequiredFormField} from "../../../../validation/FormField";
import FormValidators from "../../../../validation/FormValidators";
import FormValidation from "../../../../validation/FormValidation";
import Task from "../../../../model/task/Task";

export default class TaskForm extends BaseFormController<TaskForm> {

	public static createEmpty(): TaskForm {
		return this.createUserForm({});
	}

	public static createFromTask(task: Task): TaskForm {
		return this.createUserForm({
			title: option(task.title),
			installerDescription: option(task.installerDescription),
			customerDescription: option(task.customerDescription)
		});
	}

	private static createUserForm({
		title = none,
		installerDescription = none,
		customerDescription = none
	}) {
		const titleField = RequiredFormField.create<string>(title, "Task name is required", [
			FormValidators.nonEmptyString("Task name is required")
		]);
		return new TaskForm(
			uuidv4(),
			titleField,
			RequiredFormField.create<string>(installerDescription, "Installer description is required", [
				FormValidators.nonEmptyString("Installer description is required")
			]),
			RequiredFormField.create<string>(customerDescription, "Customer description is required", [
				FormValidators.nonEmptyString("Customer description is required")
			]),
			titleField
		);
	}

	constructor(public readonly formId: string,
		public readonly title: RequiredFormField<string>,
		public readonly installerDescription: RequiredFormField<string>,
		public readonly customerDescription: RequiredFormField<string>,
		public readonly fieldWithFocus: FormField<string>) {
		super(fieldWithFocus, formId);
	}

	onValid(callback: (data: Task) => void) {
		const result = FormValidation.validateFields(
			[this.title, this.installerDescription, this.customerDescription],
			() => {
				return new Task(
					"",
					this.title.getValue(),
					this.installerDescription.getValue().trim(),
					this.customerDescription.getValue().trim(),
				);
			}
		);
		result.onSuccess((data) => {callback(data)});
	}

	copy({
		title = this.title,
		installerDescription = this.installerDescription,
		customerDescription = this.customerDescription
	}): TaskForm {
		return new TaskForm(this.formId,
			title,
			installerDescription,
			customerDescription,
			this.fieldWithFocus);
	}

	fields(): Array<FormField<any>> {
		return [this.title, this.installerDescription, this.customerDescription,];
	}
}
